import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Field, Formik } from 'formik';
import _ from 'lodash';

import { URLS } from 'app/config/urls';

import notification from 'app/config/notification';
import lineEndpoint from 'app/api/services/lineEndpoint';
import { errorHandler } from 'app/utils/errorHandler';

import Grid from '@material-ui/core/Grid';

import CustomTextField from '../components/TextField';
import CustomDateField from '../components/DateField';
import Loading from 'app/layouts/Loading';
import PageWrapper from '../components/PageWrapper';
import SaveBox from '../components/SaveBox';
import RequestProcess from '../components/RequestProcess';
import InfoLineCompany from '../components/InfoLineCompany';

import { SERVICES_CODES } from '../../../config/services';
import { transferStripInitialValues } from '../form-configs/transfer-initial-values';
import { transferStripValidationSchema } from '../form-configs/validation-schemas';
import { validateFormikForm } from '../../../utils/forms/functions';
import CustomMaskField from './MaskField';
import helpers from '../../../utils/helpers';
import companyEndpoints from '../../../api/services/companyEndpoints';
import { generatePath } from 'react-router-dom';
import CustomFindField from './FindField';
import Drawer from '@material-ui/core/Drawer';
import FindCompany from '../pages/drawers/FindCompany';

const TransferStrip = (props) => {
    const history = useHistory();

    const { cdLinha, loading, setLoading, classes } = props;

    const [loadingCompany, setLoadingCompany] = useState(false);
    const [loadingTerm, setLoadingTerm] = useState(false);

    const servicesFilter = useRef([{ cdServico: SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA }]).current;

    const [formInitials, setFormInitials] = useState(transferStripInitialValues);
    const [requestProcessValues, setRequestProcessValues] = useState({});
    const [companyId, setCompanyId] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedName, setSubstituteName] = useState('');

    const selectedLine = useSelector((state) => state.line.selected);
    const handleCancelTransfer = () => {
        history.push(generatePath(URLS.LINES_MANAGE, { isStrip: 'strip' }));
    };

    const reset = () => {
        setFormInitials(transferStripInitialValues);
        setRequestProcessValues({});
    };

    useEffect(() => {
        (async () => {
            if (selectedLine) {
                const response = await lineEndpoint.getLastContractsByLinha(selectedLine.cdLinha);
                if (response && response.status === 200) {
                    const data = response.data;
                    setFormInitials({
                        ...formInitials,
                        nuTermoPermissao: data.nuTermo,
                    });
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLine]);

    const validateBeforeSave = (formikBag) => {
        validateFormikForm(formikBag, transferStripValidationSchema).then((res) => {
            if (Object.keys(res).length > 0) {
                notification('O(s) campo(s) sinalizado(s) precisam de revisão.', {
                    toastId: 'VALIDATION',
                    type: 'error',
                });
            } else {
                formikBag.handleSubmit();
            }
        });
    };

    const handleSearchTerm = async (term, formikBag) => {
        try {
            setLoadingTerm(true);
            const response = await lineEndpoint.getLineTransferTerms(term);
            if (response.status === 200 && response.data.length > 0) {
                const { cdLinha, dtAssinatura, dtPublicacao } = response.data[0];
                if (cdLinha !== selectedLine.cdLinha) {
                    notification('A linha do termo é diferente da linha atual', {
                        toastId: 'LINES_COMPARISON',
                        type: 'warn',
                    });
                }
                formikBag.setFieldValue('dtPublicacao', dtPublicacao);
                formikBag.setFieldValue('dtAssinatura', dtAssinatura);
            }
        } catch (e) {
        } finally {
            setLoadingTerm(false);
        }
    };

    const handleSubmitForm = async ({ values, formikHelpers }) => {
        try {
            setLoading(true);
            const valuesCopy = _.cloneDeep(values);
            valuesCopy.cdLinha = selectedLine?.cdLinha;

            valuesCopy.nuProcesso = requestProcessValues.nuProcesso;
            valuesCopy.nuSolicitacao = requestProcessValues.nuSolicitacaoFmt;
            valuesCopy.cdProcesso = requestProcessValues.cdProcesso;
            valuesCopy.cdSolicitacao = requestProcessValues.cdSolicitacao;
            valuesCopy.cdEmpresa = companyId;

            if (
                requestProcessValues.nuProcesso &&
                requestProcessValues.nuProcesso !== '' &&
                requestProcessValues.processError
            ) {
                notification('O número do processo não existe no CPA', {
                    toastId: 'VALIDATION',
                    type: 'error',
                });
                if (formikHelpers) {
                    formikHelpers.setFieldError('nuProcesso', 'O número do processo não existe no CPA');
                }
            }

            valuesCopy.deNomePermissionarioAntigo = selectedLine?.empresa?.deRazaoSocial;
            valuesCopy.deCpfCnpjAntigo = helpers.formatarDocumento(selectedLine?.empresa?.deCnpjMatriz);
            valuesCopy.deNomePermissionarioNovo = valuesCopy.deRazaoSocial;
            valuesCopy.deCpfCnpjNovo = valuesCopy.deCnpj;

            const savedTransfer = await lineEndpoint.saveTransfer(valuesCopy);

            if (savedTransfer.status === 200) {
                notification('Transferência salva com sucesso', {
                    toastId: 'SUCCESSFUL_SAVE_REQUEST',
                    type: 'success',
                });
                formikHelpers.resetForm();
                reset();
                handleCancelTransfer();
            }
        } catch (error) {
            errorHandler(error.response?.status, error.response?.data?.message);
        }
        setLoading(false);
    };

    const validateDocument = (value) => {
        let error;
        if (!helpers.validateCpfCnpj(value)) {
            error = 'Documento inválido';
        }
        return error;
    };

    const searchCompany = async ({ doc, fromField, formikBag }) => {
        let result = null;
        let error = false;
        let deCnpj = helpers.somenteAlfanumericos(doc);
        setLoadingCompany(true);
        const response = await companyEndpoints.getCompanies({ page: 0, size: 1, request: { txtBusca: deCnpj } }, '');
        if (response && response.status === 200 && response.data?.content && response.data.content.length > 0) {
            const data = response.data.content;
            if (data.length > 0) {
                result = data[0];
                setCompanyId(result.cdEmpresa);
                formikBag.setFieldValue('deRazaoSocial', result.deRazaoSocial);
                setSubstituteName(result.deRazaoSocial);
            }
        } else {
            notification('Empresa não existe no cadastro da agência. Favor verificar.', {
                toastId: 'ERROR_COMPANY',
                type: 'error',
            });
            formikBag.setFieldValue('deRazaoSocial', '');
            setSubstituteName('');
            error = true;
        }
        setLoadingCompany(false);
        if (!fromField || error) {
            return result;
        }
    };

    const handleSelectCompany = (data, formikBag) => {
        let name = data.deRazaoSocial ? data.deRazaoSocial : data.nmCompleto;
        formikBag.setFieldValue('deCnpj', data.deCnpjMatriz ? data.deCnpjMatriz : data.deCpf);
        formikBag.setFieldValue('deRazaoSocial', name);
        setCompanyId(data.cdEmpresa);
        setSubstituteName(name);
    };

    const callBackRequest = async (request, formikBag) => {
        if (request && request.jsonSolicitacao) {
            let jsonSolicitacao;

            try {
                jsonSolicitacao = JSON.parse(request.jsonSolicitacao);
            } catch (e) {
                console.error('Erro ao processar solicitação', e);
                return;
            }

            if (jsonSolicitacao.deCnpjSucessora) {
                formikBag.setFieldValue('deCnpj', jsonSolicitacao.deCnpjSucessora);
                const deCnpj = jsonSolicitacao.deCnpjSucessora;
                if (deCnpj && deCnpj !== '') {
                    const response = await searchCompany({ doc: deCnpj, formikBag });
                    if (response) {
                        const cdEmpresa = response.cdEmpresa;
                        const deRazaoSocial = response.deRazaoSocial || response.nmCompleto;
                        formikBag.setFieldValue('cdEmpresa', cdEmpresa);
                        formikBag.setFieldValue('deRazaoSocial', deRazaoSocial);
                    } else {
                        if (jsonSolicitacao.nmCompletoSucessora) {
                            formikBag.setFieldValue('deRazaoSocial', jsonSolicitacao.nmCompletoSucessora);
                        }
                    }
                }
            }
        }
    };

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={formInitials}
                initialStatus={{ holding: false }}
                validationSchema={transferStripValidationSchema}
                validateOnBlur={false}
                validateOnChange={true}
                onSubmit={(values, formikHelpers) => handleSubmitForm({ values, formikHelpers })}>
                {(formProps) => {
                    return (
                        <>
                            <PageWrapper title="Transferência de linha">
                                {loading && <Loading />}
                                <Grid container spacing={3}>
                                    <Grid item container spacing={3} direction={'row'}>
                                        <InfoLineCompany selectedLine={selectedLine} />
                                        <Grid item xs={12} sm={4}>
                                            <Field
                                                component={CustomTextField}
                                                name="nuTermoPermissao"
                                                label="Nº contrato/Termo de permissão"
                                                disabled
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <h3 className={classes.subtitle}>Empresa sucessora</h3>
                                    </Grid>
                                    <RequestProcess
                                        {...props}
                                        {...formProps}
                                        initialState={formInitials}
                                        cdLinha={cdLinha}
                                        servicesFilter={servicesFilter}
                                        requestProcessValues={requestProcessValues}
                                        setRequestProcessValues={setRequestProcessValues}
                                        callBackRequest={(request) => callBackRequest(request, formProps)}
                                        nuProcessRequired={false}
                                        fieldWidth={4}
                                    />
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            component={CustomTextField}
                                            name="nuTermoTransferencia"
                                            label="Nº Termo de transferencia*"
                                            inputProps={{
                                                maxLength: 10,
                                            }}
                                            loading={loadingTerm}
                                            disabled={loadingTerm}
                                            onBlur={(v) => {
                                                handleSearchTerm(v.target.value, formProps);
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <Field
                                            component={CustomMaskField}
                                            label="CNPJ Empresa Sucessora"
                                            name="deCnpj"
                                            mask={'**.***.***/****-99'}
                                            fullWidth
                                            onBlur={(e) => {
                                                formProps.handleBlur(e);
                                                searchCompany({
                                                    doc: e.target.value,
                                                    fromField: true,
                                                    formikBag: formProps,
                                                });
                                            }}
                                            validate={validateDocument}
                                            loading={loadingCompany}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Field
                                            component={CustomFindField}
                                            label="Razão Social Empresa Sucessora"
                                            name="deRazaoSocial"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            value={selectedName}
                                            onChange={(e) => {
                                                formProps.handleChange(e);
                                                setSubstituteName(e.target.value);
                                            }}
                                            onClickButton={() => setOpenDrawer(true)}
                                            loading={loadingCompany}
                                            inputProps={{
                                                maxLength: 150,
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            disabled={loadingTerm}
                                            component={CustomDateField}
                                            name="dtAssinatura"
                                            label="Data da assinatura"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            disabled={loadingTerm}
                                            component={CustomDateField}
                                            name="dtPublicacao"
                                            label="Data da publicação*"
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <SaveBox
                                            removeSpacing
                                            firstButtonLabel={'VOLTAR'}
                                            middleButtonLabel={formProps.status.holding ? 'Aguarde...' : 'SALVAR'}
                                            middleButtonDisabled={formProps.status.holding}
                                            onCancel={handleCancelTransfer}
                                            onSave={() => validateBeforeSave(formProps)}
                                        />
                                    </Grid>
                                </Grid>
                            </PageWrapper>
                            <Drawer anchor="right" open={openDrawer} onClose={() => setOpenDrawer(false)}>
                                <FindCompany
                                    onClose={() => setOpenDrawer(false)}
                                    onSave={(data) => handleSelectCompany(data, formProps)}
                                    requestParams={{ tipoGeral: true }}
                                />
                            </Drawer>
                        </>
                    );
                }}
            </Formik>
        </>
    );
};

export default TransferStrip;
